import {
    AppBar,
    Toolbar,
    Grid,
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    Button
} from "@mui/material"
import ArrowBackIos from '@mui/icons-material/ArrowBackIos'
import { useNavigate, useLocation } from 'react-router-dom'
import { BackDropLoading } from '../../ui-component/BackDropLoading'
import { useEffect, useState, useContext, useRef } from 'react'
import { ProfileContext } from '../../contexts/ProfileContext'

export const ServiceRequest = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [loading, setLoading] = useState(true)
    const [profile, setProfile] = useState(null)
    // const [houseInfo, setHouseInfo] = useState(null);
    const [url, setUrl] = useState(null)
    const context = useContext(ProfileContext)

    const [alert, setAlert] = useState({ open: false, title: "", message: "" });
    const [lang, setLang] = useState(sessionStorage.getItem("fast-lang") || "th");

    const genURL = (projectInfo) => {
        let accessToken = "dummy"
        let clientId = projectInfo.client_id
        let projectId = projectInfo.project_id

        return setUrl(`${projectInfo.client_url}/backend/public/serviceRequestDocument/job-create/1?clientId=${clientId}&projectId=${projectId}`)
    }

    const genURLForLineOA = ({ company_code , project_code, unit_code, url_api_fast_inspect }) => {
        let accessToken = "dummy"
        return setUrl(`${url_api_fast_inspect}/backend/public/serviceRequestDocument/job-create/1?client_code=${company_code}&project_code=${project_code}&unit_code=${unit_code}`)
    }

    useEffect(() => {
        if (!location.state?.projectInfo) {

            let profile = context.state?.profile?.customer[0]
            let houseInfo = context.state?.houseInfo
            
            genURLForLineOA({ 
                company_code : profile?.company_code, 
                project_code: houseInfo?.project_id, 
                unit_code: houseInfo?.unit_number, 
                url_api_fast_inspect: profile?.url_api_fast_inspect.split("/api/v1")[0] 
            })
        }else {
            genURL(location.state?.projectInfo)
        }

    }, [context])

      useEffect(() => {
        const handleMessage = (event) => {
            console.log("Full message:", event.data);
        const { eventName, message } = event.data;
        if (eventName === "saveServiceRequestHandlerOnSuccess") {
            console.log("✅ Success:", message);

            setAlert({
            open: true,
            title:
                lang === "th"
                ? "สร้าง Service Request สำเร็จ"
                : "Created Service Request Successfully",
            message: message || "",
            });           
        }

        if (eventName === "saveServiceRequestHandlerOnError") {
            console.log("❌ Error:", message);

            setAlert({
                open: true,
                title:
                    lang === "th"
                    ? "สร้าง Service Request ไม่สำเร็จ"
                    : "Failed to Create Service Request",
                message: message || "",
            });
        }
          // IMPORTANT: Verify the origin of the message for security
        //   if (event.origin !== 'http://your-iframe-origin.com') {
        //     return; // Discard messages from untrusted origins
        //   }

          // Process the received data
        //   setReceivedMessage(event.data);
          console.log('Message received from iframe:', event.data);
        };

        window.addEventListener("message", (event) => {
            handleMessage(event);
        });
        // Clean up the event listener when the component unmounts
        return () => {
          window.removeEventListener('message', handleMessage);
        };
      }, []);

      useEffect(() => {
        console.log("ServiceRequest url", url);
      }, [url])

    return <>
        <AppBar sx={{
            position: 'fixed',
            boxShadow: 'none',
            height: 60,
        }}>
            <Toolbar>
                <Grid container item xs={1}>
                    <ArrowBackIos onClick={() => navigate(-1)} />
                </Grid>
                <Grid container item xs={10} direction="row"
                    justifyContent="center"
                >
                    <Typography>
                        Service Request
                    </Typography>

                </Grid>
            </Toolbar>
        </AppBar>
        <Box style={{ height: "calc(100dvh - 60px)", marginTop: "60px" }}>
            {
                url && <iframe
                style={{ height: "100%", width: "100vw" }}
                src={url}
                onLoad={() => setLoading(false)}
            >
            </iframe>
            }
            
        </Box>
        <BackDropLoading
            loading={loading}
        />

        <>
            <Dialog open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
                <DialogTitle>{alert.title}</DialogTitle>
                <DialogContent>
                <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                    {alert.message}
                </Typography>
                <Button
                    onClick={() => setAlert({ ...alert, open: false })}
                    sx={{ mt: 2 }}
                    variant="contained"
                >
                {lang === "th" ? "ปิด" : "Close"}
                </Button>
                </DialogContent>
            </Dialog>
        </>

    </>
}